const caseReferenceFileStyles = {
  button: { width: 300 },
};

export default caseReferenceFileStyles;
